const firebaseConfig = {
  apiKey: "AIzaSyDVnap2ACk-yRvvUTrZL3ab1B8yufBQmmI",
  authDomain: "volunteer-network-client-b6b6a.firebaseapp.com",
  databaseURL: "https://volunteer-network-client-b6b6a.firebaseio.com",
  projectId: "volunteer-network-client-b6b6a",
  storageBucket: "volunteer-network-client-b6b6a.appspot.com",
  messagingSenderId: "703714889783",
  appId: "1:703714889783:web:0f2bc1eb4eb61312bbefb2"
};

export default firebaseConfig;